import { RoutesT } from '@/routes/Routes.types';
import IcoHanger from '@/assets/svg/ico_hanger.svg?react';
import IcoHome from '@/assets/svg/ico_home.svg?react';
import IcoOutfitsGenerate from '@/assets/svg/ico_outfits_generate.svg?react';
import IcoPlaner from '@/assets/svg/ico_planer.svg?react';
import IcoSuitcase from '@/assets/svg/ico_suitcase.svg?react';
import IcoWardrobe from '@/assets/svg/ico_wardrobe.svg?react';
import {
    LazyApplicationFormPage,
    LazyHomePage,
    LazyPlanerPage,
    LazyProfilePage,
    LazyProfileChangeEmailPage,
    LazySuitcasesAddPage,
    LazySuitcasesPage,
    LazySuitcasesSinglePage,
    LazyWardrobeAddPage,
    LazyWardrobePage,
    LazyWardrobeClothingPage,
    LazyWardrobeClothingSinglePage,
    LazyOutfitsCreatePage,
    LazyOutfitsPage,
    LazyOutfitsSinglePage,
    LazyOutfitsTinderPage,
    LazyPlanerAddEventPage,
    LazyPlanerSingleEventPage,
} from '@/pages';

export const privateRoutes: RoutesT = {
    applicationForm: {
        path: '/application',
        label: 'Заявка для брендов',
        element: <LazyApplicationFormPage />,
        title: 'Заявка для брендов',
        description: 'Оставьте заявку для сотрудничества с брендами.',
    },
    home: {
        path: '/main',
        label: 'Главная',
        element: <LazyHomePage />,
        icon: <IcoHome />,
        title: 'Ваш цифровой гардероб',
        description:
            'Цифровой гардероб, подбор образов, чемодан за минуту и события.',
        showTabBar: true,
    },
    outfits: {
        path: '/outfits',
        label: 'Мои образы',
        element: <LazyOutfitsPage />,
        title: 'Мои образы',
        description: 'Смотрите ваши образы и создавайте новые.',
        showTabBar: true,
        subRoutes: {
            outfitsCreate: {
                path: '/outfits/create',
                label: 'Собрать образ',
                element: <LazyOutfitsCreatePage />,
                icon: <IcoOutfitsGenerate />,
                title: 'Подбор образа',
                description:
                    'Создавайте собственные образы на основе вашего гардероба.',
            },
            outfitTinder: {
                path: '/outfits/tinder',
                label: 'Примерка',
                element: <LazyOutfitsTinderPage />,
            },
            outfitsSingle: {
                path: '/outfits/:id',
                label: 'Мой образ',
                element: <LazyOutfitsSinglePage />,
            },
        },
    },
    planer: {
        path: '/planer',
        label: 'Планировщик',
        icon: <IcoPlaner />,
        element: <LazyPlanerPage />,
        title: 'Планировщик одежды',
        description: 'Планируйте образы на дни, события и поездки.',
        showTabBar: true,
        subRoutes: {
            planerAddEvent: {
                path: '/planer/add-event',
                label: 'Событие',
                icon: <IcoHanger />,
                element: <LazyPlanerAddEventPage />,
                title: 'Создать событие',
                description: 'Создайте событие для любого дня.',
            },
            planerSingleEvent: {
                path: '/planer/:id',
                label: 'Событие',
                element: <LazyPlanerSingleEventPage />,
                title: 'Редактировать событие',
                description:
                    'Смотрите и редактируйте запланированный образ и событие.',
            },
        },
    },
    profile: {
        path: '/profile',
        label: 'Профиль',
        element: <LazyProfilePage />,
        title: 'Профиль',
        description: 'Управляйте аккаунтом и настройками.',
        subRoutes: {
            profileChangeEmail: {
                path: '/profile/change-email',
                label: 'Добавить почту',
                element: <LazyProfileChangeEmailPage />,
                title: 'Добавить почту',
                description: 'Добавьте или измените почту.',
            },
        },
    },
    suitcases: {
        path: '/suitcases',
        label: 'Чемоданы',
        icon: <IcoSuitcase />,
        element: <LazySuitcasesPage />,
        title: 'Мои чемоданы',
        description:
            'Собирайте чемодан за минуту с учетом погоды, длительности и формата поездки.',
        showTabBar: true,
        subRoutes: {
            suitcasesAdd: {
                path: '/suitcases/add',
                label: 'Собрать чемодан',
                icon: <IcoSuitcase />,
                element: <LazySuitcasesAddPage />,
                title: 'Собрать чемодан',
                description: 'Создайте новый чемодан.',
            },
            suitcasesEdit: {
                path: '/suitcases/:id/edit',
                label: 'Собрать чемодан',
                icon: <IcoSuitcase />,
                element: <LazySuitcasesAddPage />,
                title: 'Собрать чемодан',
                description: 'Измените данные чемодана.',
            },
            suitcasesSingle: {
                path: '/suitcases/:id',
                label: 'Мой чемодан',
                icon: <IcoSuitcase />,
                element: <LazySuitcasesSinglePage />,
                title: 'Мой чемодан',
                description: 'Все изделия, собранные для поездки.',
            },
        },
    },
    wardrobe: {
        path: '/wardrobe',
        label: 'Мой гардероб',
        icon: <IcoWardrobe />,
        element: <LazyWardrobePage />,
        title: 'Мой гардероб',
        description: 'Ваш цифровой гардероб: храните изделия и образы.',
        showTabBar: true,
        subRoutes: {
            wardrobeAdd: {
                path: '/wardrobe/add',
                label: 'Добавить в гардероб',
                icon: <IcoHanger />,
                element: <LazyWardrobeAddPage />,
                title: 'Добавить изделие',
                description: 'Добавляйте одежду в цифровой гардероб.',
            },
            wardrobeClothing: {
                path: '/wardrobe/clothing',
                label: 'Поиск одежды',
                element: <LazyWardrobeClothingPage />,
                title: 'Поиск одежды',
                description:
                    'Ищите изделия в своём гардеробе, управляйте категориями и фильтрами.',
                subRoutes: {
                    wardrobeClothingSingle: {
                        path: '/wardrobe/clothing/:id',
                        label: 'Редактирование изделия',
                        element: <LazyWardrobeClothingSinglePage />,
                        title: 'Редактирование изделия',
                        description:
                            'Редактируйте параметры изделий: тип, цвет, сезон, стиль.',
                    },
                },
            },
        },
    },
};
